<template>
  <div class="lead-dashboard-container pl-5 pr-3">
    <div class="py-5 text-h5 font-weight-bold">Team lead dashboard</div>

    <div class="contents">
      <div class="table-column">
        <TableWithTools
          :reportData="mainData"
          @Report-Data="handleWorkspaceClick"
          @filter-Data="handleFilterData"
        />
      </div>
      <div class="card-column">
        <ReportDoyouknow
          :workspaceId="workspaceId"
          :projectId="projectId"
          :accountId="accountId"
          :mainFilterData="filterData"
          @Report-Data="handleWorkspaceClick"
        />
      </div>
      <!-- <div style="width: 29%">
        <ReportWorkinprogress />
      </div> -->
    </div>
  </div>
</template>

<script>
import reportData from "./reportData.json";
import TableWithTools from "./TableWithTools.vue";
import ReportDoyouknow from "./ReportDoyouknow.vue";
//import ReportWorkinprogress from "./ReportWorkinprogress.vue";
export default {
  components: {
    TableWithTools,
    ReportDoyouknow,
    // ReportWorkinprogress,
  },
  data() {
    return {
      mainData: reportData,
      workspaceId: null,
      projectId: null,
      accountId: null,
      filterData: null,
    };
  },
  methods: {
    handleWorkspaceClick(payload) {
      const projectId = payload.projectId;
      const accountId = payload.accountId;
      this.projectId = projectId;
      this.accountId = accountId;
    },
    handleFilterData(payload) {
      const filterData = payload.filterData;
      this.filterData = filterData;
    },
  },
};
</script>

<style>
.lead-dashboard-container {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
}

.contents {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 16px;
  width: 100%;
  align-items: stretch;
  box-sizing: border-box;
}

.table-column {
  flex: 1 1 58%;
  min-width: 0;
  width: 58%;
}

.card-column {
  flex: 0 0 40%;
  min-width: 320px;
  max-width: 520px;
  width: 40%;
}

@media (min-width: 1600px) {
  .table-column {
    flex: 1 1 63%;
    width: 63%;
  }
  .card-column {
    flex: 0 0 36%;
    min-width: 360px;
    max-width: 540px;
    width: 36%;
  }
}

@media (max-width: 1440px) and (min-width: 1200px) {
  .table-column {
    flex: 1 1 60%;
    width: 60%;
  }
  .card-column {
    flex: 0 0 39%;
    min-width: 320px;
    max-width: 480px;
    width: 39%;
  }
}

@media (max-width: 1199px) {
  .contents {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    gap: 12px;
  }
  .table-column {
    flex: 1 1 auto;
    min-width: 0;
    width: 58%;
  }
  .card-column {
    flex: 0 0 40%;
    min-width: 290px;
    max-width: 450px;
    width: 40%;
  }
}

.details {
  color: #000;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 300;
  text-transform: capitalize;
}

.cardTitle {
  color: #272727;
  font-size: 18px;
  font-weight: 700;
}

.reff {
  display: flex;
  gap: 3px;
  color: #64748b;
  font-size: 11.5px;
  font-weight: 500;
}

.dateRow {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
}

.dateAndP {
  display: flex;
  font-size: 10px;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
}

.issueName {
  color: #0f172a;
  font-size: 13.5px;
  font-weight: 600;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
  word-break: break-word;
  padding-bottom: 2px;
}

.priority {
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.chip {
  text-transform: capitalize;
  border: 1px solid #f9c644;
  background: #ffe8ae;
  color: #000;
  font-size: 10.5px;
  font-weight: 500;
  padding: 2px 6px;
  height: fit-content;
  width: fit-content;
  border-radius: 4px;
  white-space: nowrap;
}

.assignToPart {
  overflow: scroll;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

>>> .p-avatar.p-avatar-lg {
  width: 2.75rem;
  height: 2.75rem;
  font-size: 16px;
  flex-shrink: 0;
}
</style>
